"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var BigNumberRangeValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var IntegerPositiveValidator_1 = require("../../core/model/data-dictionary/validators/IntegerPositiveValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var LockTypeEnum_1 = require("../../product/model/LockTypeEnum");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var SupplierAgreement_1 = require("../../supply/model/SupplierAgreement");

var UserInfo_1 = require("../../user/model/UserInfo");

var PosTypeEnum_1 = require("../../window/model/PosTypeEnum");

var WindowItemSitesData_1 = require("../../window/model/WindowItemSitesData");

var WindowStateEnum_1 = require("../../window/model/WindowStateEnum");

var ReplenishmentPromoManagementRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReplenishmentPromoManagementRowDTO, _DomainObject_1$Domai);

  function ReplenishmentPromoManagementRowDTO(editable, // promo
  promoId, promoExtId, promoName, promoWFState, storeSpecification, promoTypeId, promoValidFrom, promoValidTo, promoGosId, // window
  windowId, windowWFState, // window item
  windowItemId, sitesData, posActionFlag, posMechanics, posType, requestSecondaryPlacement, secondaryPlacement, onPicture, logisticComment, returnable, returnableCondition, endDateOfReturn, distributionModelId, distributionModelDays, lastDistrModelIdChangeTime, lastDistrModelIdChangeUser, lockType, selloutSales, directDelivery, directDeliverySites, ignoreForTraining, substituteProductId, substituteProductExtId, substituteProductName, tastings, marketingComment, systemVolume, promoVolume, regularVolume, cmForecast, activeSale, extraSaleSticker, justInTime, promoPrice, regularPrice, // public readonly warningFlags: FlagSet<WindowItemWarningFlag>,
  warningStrings, groupOfSitesId, // supplier agreement
  supplierAgreementId, obligatoryToBuy, split, minimalVolume, maximalVolume, otherSuppliers, purchaseForecastSMPA, confirmedPurchaseForecastSMPA, promoPurchaseStartDate, promoPurchaseEndDate, // product
  productId, productExtId, productName, // product categories
  productCatDepartment, productCatSCM, productCatCM, productCatCategoryPlan, productCat4BOX, // supplier
  supplierId, supplierExtId, supplierName, // promo member credits
  creditsEnabled, creditsAmountForPurchase, creditsHealthyAmountForPurchase, creditsPurchaseQuantity, // withException
  sites) {
    var _this;

    _classCallCheck(this, ReplenishmentPromoManagementRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementRowDTO).call(this));
    _this.editable = editable;
    _this.promoId = promoId;
    _this.promoExtId = promoExtId;
    _this.promoName = promoName;
    _this.promoWFState = promoWFState;
    _this.storeSpecification = storeSpecification;
    _this.promoTypeId = promoTypeId;
    _this.promoValidFrom = promoValidFrom;
    _this.promoValidTo = promoValidTo;
    _this.promoGosId = promoGosId;
    _this.windowId = windowId;
    _this.windowWFState = windowWFState;
    _this.windowItemId = windowItemId;
    _this.sitesData = sitesData;
    _this.posActionFlag = posActionFlag;
    _this.posMechanics = posMechanics;
    _this.posType = posType;
    _this.requestSecondaryPlacement = requestSecondaryPlacement;
    _this.secondaryPlacement = secondaryPlacement;
    _this.onPicture = onPicture;
    _this.logisticComment = logisticComment;
    _this.returnable = returnable;
    _this.returnableCondition = returnableCondition;
    _this.endDateOfReturn = endDateOfReturn;
    _this.distributionModelId = distributionModelId;
    _this.distributionModelDays = distributionModelDays;
    _this.lastDistrModelIdChangeTime = lastDistrModelIdChangeTime;
    _this.lastDistrModelIdChangeUser = lastDistrModelIdChangeUser;
    _this.lockType = lockType;
    _this.selloutSales = selloutSales;
    _this.directDelivery = directDelivery;
    _this.directDeliverySites = directDeliverySites;
    _this.ignoreForTraining = ignoreForTraining;
    _this.substituteProductId = substituteProductId;
    _this.substituteProductExtId = substituteProductExtId;
    _this.substituteProductName = substituteProductName;
    _this.tastings = tastings;
    _this.marketingComment = marketingComment;
    _this.systemVolume = systemVolume;
    _this.promoVolume = promoVolume;
    _this.regularVolume = regularVolume;
    _this.cmForecast = cmForecast;
    _this.activeSale = activeSale;
    _this.extraSaleSticker = extraSaleSticker;
    _this.justInTime = justInTime;
    _this.promoPrice = promoPrice;
    _this.regularPrice = regularPrice;
    _this.warningStrings = warningStrings;
    _this.groupOfSitesId = groupOfSitesId;
    _this.supplierAgreementId = supplierAgreementId;
    _this.obligatoryToBuy = obligatoryToBuy;
    _this.split = split;
    _this.minimalVolume = minimalVolume;
    _this.maximalVolume = maximalVolume;
    _this.otherSuppliers = otherSuppliers;
    _this.purchaseForecastSMPA = purchaseForecastSMPA;
    _this.confirmedPurchaseForecastSMPA = confirmedPurchaseForecastSMPA;
    _this.promoPurchaseStartDate = promoPurchaseStartDate;
    _this.promoPurchaseEndDate = promoPurchaseEndDate;
    _this.productId = productId;
    _this.productExtId = productExtId;
    _this.productName = productName;
    _this.productCatDepartment = productCatDepartment;
    _this.productCatSCM = productCatSCM;
    _this.productCatCM = productCatCM;
    _this.productCatCategoryPlan = productCatCategoryPlan;
    _this.productCat4BOX = productCat4BOX;
    _this.supplierId = supplierId;
    _this.supplierExtId = supplierExtId;
    _this.supplierName = supplierName;
    _this.creditsEnabled = creditsEnabled;
    _this.creditsAmountForPurchase = creditsAmountForPurchase;
    _this.creditsHealthyAmountForPurchase = creditsHealthyAmountForPurchase;
    _this.creditsPurchaseQuantity = creditsPurchaseQuantity;
    _this.sites = sites;
    return _this;
  }

  return ReplenishmentPromoManagementRowDTO;
}(DomainObject_1.DomainObject);

exports.ReplenishmentPromoManagementRowDTO = ReplenishmentPromoManagementRowDTO;

ReplenishmentPromoManagementRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReplenishmentPromoManagementRowDTO.name);
  return {
    editable: builder.bool('editable'),
    promoId: builder.str('promoId'),
    promoExtId: builder.str('promoExtId'),
    promoName: builder.str('promoName'),
    promoWFState: builder.opt(builder.senum('promoWFState', PromotionStateEnum_1.PromotionStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionWorkflowState)),
    storeSpecification: builder.senum('storeSpecification', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification),
    promoTypeId: builder.lookup('promoTypeId', CodebookLookupSequence_1.CodebookLookupSequence.PromotionTypes),
    promoValidFrom: builder.date('promoValidFrom', DateParser_1.DateParser.ISO_PATTERN),
    promoValidTo: builder.date('promoValidTo', DateParser_1.DateParser.ISO_PATTERN),
    promoGosId: builder.str('promoGosId'),
    windowId: builder.str('windowId'),
    windowWFState: builder.opt(builder.senum('windowWFState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    windowItemId: builder.str('windowItemId'),
    sitesData: builder.obj('sitesData', WindowItemSitesData_1.WindowItemSitesData.schema, function (mat) {
      return WindowItemSitesData_1.WindowItemSitesData.fromDataDict(mat);
    }),
    posActionFlag: builder.bool('posActionFlag'),
    posMechanics: builder.opt(builder.str('posMechanics')),
    posType: builder.senum('posType', PosTypeEnum_1.PosTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.PosType),
    requestSecondaryPlacement: builder.bool('requestSecondaryPlacement'),
    secondaryPlacement: builder.str('secondaryPlacement'),
    onPicture: builder.bool('onPicture'),
    logisticComment: builder.opt(builder.trimStr('logisticComment')),
    returnable: builder.bool('returnable'),
    returnableCondition: builder.opt(builder.str('returnableCondition')),
    endDateOfReturn: builder.opt(builder.date('endDateOfReturn', DateParser_1.DateParser.ISO_PATTERN)),
    distributionModelId: builder.lookup('distributionModelId', CodebookLookupSequence_1.CodebookLookupSequence.DistributionModel),
    distributionModelDays: builder.opt(builder.num('distributionModelDays', new IntegerPositiveValidator_1.IntegerPositiveValidator(false))),
    lastDistrModelIdChangeTime: builder.opt(builder.date('lastDistrModelIdChangeTime', DateParser_1.DateParser.ISO_PATTERN)),
    lastDistrModelIdChangeUser: builder.opt(builder.obj('lastDistrModelIdChangeUser', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })),
    lockType: builder.senum('lockType', LockTypeEnum_1.LockTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.LockType),
    selloutSales: builder.bool('selloutSales'),
    directDelivery: builder.bool('directDelivery'),
    directDeliverySites: builder.opt(builder.str('directDeliverySites')),
    ignoreForTraining: builder.bool('ignoreForTraining'),
    substituteProductId: builder.opt(builder.str('substituteProductId')),
    substituteProductExtId: builder.opt(builder.str('substituteProductExtId')),
    substituteProductName: builder.opt(builder.str('substituteProductName')),
    tastings: builder.bool('tastings'),
    marketingComment: builder.opt(builder.trimStr('marketingComment')),
    systemVolume: builder.opt(builder.bigNum('systemVolume')),
    promoVolume: builder.bigNum('promoVolume'),
    regularVolume: builder.opt(builder.bigNum('regularVolume')),
    cmForecast: builder.opt(builder.bigNum('cmForecast')),
    activeSale: builder.bool('activeSale'),
    extraSaleSticker: builder.bool('extraSaleSticker'),
    justInTime: builder.bool('justInTime'),
    // warningFlags: builder.flags('warningFlags', WindowItemWarningFlag),
    warningStrings: builder.listOf(builder.str('warningStrings')),
    supplierAgreementId: builder.str('supplierAgreementId'),
    obligatoryToBuy: builder.bool('obligatoryToBuy'),
    split: builder.bigNum('split', new BigNumberRangeValidator_1.BigNumberRangeValidator(SupplierAgreement_1.SupplierAgreement.SPLIT_VALUE_MIN, SupplierAgreement_1.SupplierAgreement.SPLIT_VALUE_MAX)),
    minimalVolume: builder.opt(builder.bigNum('minimalVolume')),
    maximalVolume: builder.opt(builder.bigNum('maximalVolume')),
    otherSuppliers: builder.num('otherSuppliers'),
    purchaseForecastSMPA: builder.opt(builder.bigNum('purchaseForecastSMPA')),
    confirmedPurchaseForecastSMPA: builder.opt(builder.bigNum('confirmedPurchaseForecastSMPA')),
    promoPurchaseStartDate: builder.opt(builder.date('promoPurchaseStartDate', DateParser_1.DateParser.ISO_PATTERN)),
    promoPurchaseEndDate: builder.opt(builder.date('promoPurchaseEndDate', DateParser_1.DateParser.ISO_PATTERN)),
    groupOfSitesId: builder.opt(builder.str('groupOfSitesId')),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    // product
    productId: builder.str('productId'),
    productExtId: builder.str('productExtId'),
    productName: builder.str('productName'),
    // product categories
    productCatDepartment: builder.str('productCatDepartment'),
    productCatSCM: builder.str('productCatSCM'),
    productCatCM: builder.str('productCatCM'),
    productCatCategoryPlan: builder.str('productCatCategoryPlan'),
    productCat4BOX: builder.str('productCat4BOX'),
    // supplier
    supplierId: builder.str('supplierId'),
    supplierExtId: builder.str('supplierExtId'),
    supplierName: builder.str('supplierName'),
    // promo member credits
    creditsEnabled: builder.opt(builder.bool('creditsEnabled')),
    creditsAmountForPurchase: builder.opt(builder.num('creditsAmountForPurchase')),
    creditsHealthyAmountForPurchase: builder.opt(builder.num('creditsHealthyAmountForPurchase')),
    creditsPurchaseQuantity: builder.opt(builder.num('creditsPurchaseQuantity')),
    // withExceptions
    sites: builder.opt(builder.listOf(builder.str('sites')))
  };
}();